import { CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'

/**
 * Nested structure for saving candidate filter state with metadata
 * This format includes type and version for format detection
 */
export type CandidateFilterStateWithMetadata = {
    type: 'candidateFilterState'
    version: '1'
    filters: CandidateFilterState
}

/**
 * Wraps CandidateFilterState with metadata structure for saving
 * @param state The CandidateFilterState to wrap
 * @returns CandidateFilterStateWithMetadata with type and version
 */
export function wrapCandidateFilterState(
    state: CandidateFilterState
): CandidateFilterStateWithMetadata {
    return {
        type: 'candidateFilterState',
        version: '1',
        filters: state,
    }
}

/**
 * Unwraps CandidateFilterStateWithMetadata to get the filters
 * @param wrapped The wrapped filter state with metadata
 * @returns The unwrapped CandidateFilterState
 */
export function unwrapCandidateFilterState(
    wrapped: CandidateFilterStateWithMetadata
): CandidateFilterState {
    return wrapped.filters
}
